import React, { useEffect, useState } from "react";
import { Box, Flex, Image, Avatar, Text } from "@chakra-ui/react";
import axios from "axios";
import { API_URL } from "../config";
import { getToken } from "../token";
import SidebarLink from "./SidebarLink";
import { useLocation } from "react-router-dom";
import { FORUM } from "../Theme/styles";
import {
  visibleCategories,
  categoryPath,
  MY_TASKS_PATH,
  PROJECT_STATUS_PATH,
  ROADMAP_PATH,
  ACTIVITY_PATH,
  LOGS_PATH,
} from "../categories";
import { FaUserCheck, FaFlag, FaHistory, FaMapSigns, FaUserShield } from "react-icons/fa";
import { isRcon, canSeeLogs } from "../permissions";

export const TrescMenu = ({ onWybor }) => {
  const location = useLocation();
  const [active, setActive] = useState(location.pathname);
  const [postep, setPostep] = useState(null);

  useEffect(() => {
    setActive(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    axios
      .get(`${API_URL}/roadmap`, {
        withCredentials: true,
        headers: { Authorization: `Bearer ${getToken()}` },
      })
      .then((r) => setPostep(r.data ? r.data.progress : null))
      .catch(() => setPostep(null));
  }, [location.pathname]);

  return (
    <Flex direction={"column"} h="100%" w="100%" onClick={onWybor}>
      <Flex direction={"row"} gap="3" alignItems={"center"} px={4} py={5}>
        <Image src="./logo.svg" alt="Logo" height={"28px"} />
        <Flex direction={"column"} gap={0} lineHeight={"1.15"} minW={0}>
          <Text
            fontSize={"sm"}
            fontWeight={"600"}
            color={FORUM.tekstJasny}
            noOfLines={1}
          >
            socialproject.pl
          </Text>
          <Text
            fontSize={"10px"}
            letterSpacing={"0.08em"}
            textTransform={"uppercase"}
            color={FORUM.tekstPrzygaszony}
          >
            To-do
          </Text>
        </Flex>
      </Flex>
      <Flex direction={"column"} w="100%" gap={0.5} overflowY={"auto"}>
        <SidebarLink
          title={"Moje zadania"}
          icon={FaUserCheck}
          path={MY_TASKS_PATH}
          active={active}
        />
        <Flex
          h={"1px"}
          bg={FORUM.obramowanie}
          mx={4}
          my={2}
          flexShrink={0}
        />
        {visibleCategories(isRcon()).map((k) => (
          <SidebarLink
            key={k.key}
            title={k.name}
            icon={k.ikona}
            path={categoryPath(k.key)}
            active={active}
          />
        ))}
      </Flex>
      <Flex
        direction={"column"}
        mt={"auto"}
        w={"100%"}
        borderTop={"1px solid"}
        borderColor={FORUM.obramowanie}
        pt={1}
      >
        {postep !== null && (
          <Flex direction={"column"} gap={1} px={4} pt={1} pb={3}>
            <Flex align={"center"} justify={"space-between"}>
              <Text fontSize={"11px"} color={FORUM.tekstPrzygaszony}>
                Postęp projektu
              </Text>
              <Text fontSize={"11px"} fontWeight={"600"} color={"#6C99FF"}>
                {postep}%
              </Text>
            </Flex>
            <Box h={"4px"} borderRadius={"full"} bg={FORUM.plakietka} overflow={"hidden"}>
              <Box h={"100%"} w={`${postep}%`} bg={"#6C99FF"} />
            </Box>
          </Flex>
        )}

        <Flex direction={"column"} w={"100%"}>
          <SidebarLink
            title={"Status projektu"}
            icon={FaFlag}
            path={PROJECT_STATUS_PATH}
            active={active}
          />
          <SidebarLink
            title={"Roadmapa Kacperka"}
            icon={FaMapSigns}
            path={ROADMAP_PATH}
            active={active}
          />
          <SidebarLink
            title={"Dziennik"}
            icon={FaHistory}
            path={ACTIVITY_PATH}
            active={active}
          />
          {canSeeLogs() && (
            <SidebarLink
              title={"Logi"}
              icon={FaUserShield}
              path={LOGS_PATH}
              active={active}
            />
          )}
        </Flex>
      </Flex>

      <Flex
        w="100%"
        align={"center"}
        gap={3}
        px={4}
        py={4}
        borderTop={"1px solid"}
        borderColor={FORUM.obramowanie}
      >
        <Avatar size="sm" src={localStorage.getItem("avatar")} />
        <Text fontSize={"sm"} color={FORUM.tekst} noOfLines={1}>
          {localStorage.getItem("nickname") || "—"}
        </Text>
      </Flex>
    </Flex>
  );
};

const Sidebar = () => (
  <Flex
    direction={"column"}
    h="100vh"
    w="240px"
    flexShrink={0}
    bg={FORUM.tlo}
    color={FORUM.tekst}
    borderRight={"1px solid"}
    borderColor={FORUM.obramowanie}
    display={{ base: "none", md: "flex" }}
  >
    <TrescMenu />
  </Flex>
);

export default Sidebar;
